<template>
    <v-dialog v-model="dialog2" persistent max-width="400px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          >Add New
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Add Payment</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="form1"
            >
            <v-row>
              <v-col cols="12">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="payment.from_date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="payment.from_date"
                      label="Start Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="payment.from_date" :rules="[v => !!v || 'Item is required']" no-title scrollable @change="$refs.menu.save(payment.from_date)">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(payment.from_date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :return-value.sync="payment.to_date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="payment.to_date"
                      label="Deadline Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="payment.to_date" :rules="[v => !!v || 'Item is required']" no-title scrollable @change="$refs.menu1.save(payment.to_date)">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu1.save(payment.to_date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="payment.amount"
                  label="Payment Amount"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog2 = false">Close</v-btn>
          <v-btn color="success darken-1" text @click="addpayment1()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters,mapActions } from 'vuex';
//import sendMessage from '../../apis/sendMessage.js';
  export default {
    props : {
        subscriptionid : Number
    },
    data: function() {
      return {
        dialog2: false,
        payment: {
            form_date : '',
            to_date: '',
            subscription_id: this.subscriptionid,
            user_id: '',
            amount: 0,
        },
      }
    },
    computed: {
      ...mapGetters(["allusers","currentuser","allsubscriptions"]),
    },
    created() {
        this.payment.user_id = this.currentuser.id;
    },
    methods:{
      ...mapActions(['addpayment']),
      addpayment1() {
        if(this.$refs.form1.validate())
        {
          this.payment.user_id = this.currentuser.id;
          this.addpayment(this.payment);
          this.dialog2 = false;
        }
      }
    }
  }
</script>